import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

// Types
import { AppDispatch } from 'types/RootState.types';

// Config
import { setRouterLocation } from './routerAdapter';
import { locationChanged } from '@redux/actions/navigation/navigationActions';

const RouterSync = () => {
  const location = useLocation();
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    setRouterLocation(location);
    dispatch(locationChanged(location));
  }, [location]);

  return null;
};

export default RouterSync;
